import { render } from "./BoardHome.vue?vue&type=template&id=538b8a6e"
import script from "./BoardHome.vue?vue&type=script&lang=js"
export * from "./BoardHome.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__